function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.884 6.188l7.118 4.083V2.102L3.884 6.188zm9.118-4.085v8.168l7.114-4.083-7.114-4.085zm1.008 9.895l7.115-4.083v8.17l-7.114-4.087zm6.107 5.814l-7.115-4.086v8.172l7.115-4.086zm-9.115 4.086L3.884 17.81l7.118-4.086v8.173zM2.875 7.915v8.17l7.118-4.087-7.118-4.083z",
  fill: "current"
});

function SvgPod(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgPod;